import { put, call } from 'redux-saga/effects';
import { clientProductionCreateAPI, clientProductionSearchAPI, clientProductionUpdateAPI } from 'src/api/ClientProductionApi';
import { SEARCH_RECORD_PAGE_LIMIT } from 'src/constants/CommonConstants';
import { headerShowAction } from 'src/containers/header-container/actions/HeaderActions';
import { takeFirstSagaUtil } from 'src/utils/ReduxSagaUtils';
import { toast } from 'react-toastify';
import { CLIENT_PRODUCTION_ACTIONS } from '../actions/ClientProductionActions';

function* search({
    where, currentPage = 0, autopopulate = true, fullTextSearch = true,
} = {}) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(clientProductionSearchAPI, {
            where,
            pageLength: SEARCH_RECORD_PAGE_LIMIT,
            currentPage,
            autopopulate,
        });
        yield put({
            type: CLIENT_PRODUCTION_ACTIONS.CLIENT_PRODUCTION_SEARCH_SUCCESS,
            data,
        });

        return data;
    }
    catch (error) {
        console.error('LOG: function*search -> error', error);
        yield put({
            type: CLIENT_PRODUCTION_ACTIONS.CLIENT_PRODUCTION_SEARCH_ERROR,
        });
        return null;
    }
}

function* edit({
    _id,
}) {
    try {
        const {
            data: {
                data: {
                    data,
                },
            },
        } = yield call(clientProductionSearchAPI, {
            where: {
                _id,
            },
            autopopulate: false,
        });

        if (!data || !data[0]) {
            
            yield put(headerShowAction({
                data: 'Unable to Edit, something when wrong',
            }));
        }

        
        yield put({
            type: CLIENT_PRODUCTION_ACTIONS.CLIENT_PRODUCTION_UPSERT_SUCCESS,
            data: data[0],
        });
    }
    catch (error) {
        console.error('LOG: error', error);

        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put(headerShowAction({
            data: error.response.data.data,
        }));
    }
}

function* insert(payload) {
    try {
        const {
            data: {
                data,
            },
        } = yield call(clientProductionCreateAPI, payload);

        yield put(headerShowAction({
            data: 'Created',
        })); 
        toast("Production Created")
        
        yield put({
            type: CLIENT_PRODUCTION_ACTIONS.CLIENT_PRODUCTION_UPSERT_SUCCESS,
            data: {
                ...payload,
                _id: data._id,
            },
        });
        yield put({
            type: CLIENT_PRODUCTION_ACTIONS.CLIENT_PRODUCTION_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: CLIENT_PRODUCTION_ACTIONS.CLIENT_PRODUCTION_UPSERT_ERROR,
        });
    }
}

function* update(productionId, payload) {
    try {
        yield call(clientProductionUpdateAPI, {
            productionId,
            data: payload,
        });

        yield put(headerShowAction({
            data: 'Updated',
        }));
        if(payload.deleted===true){
            toast("Production deleted")
        }
        else{
            toast("Production updated")
        } 
        
        yield put({
            type: CLIENT_PRODUCTION_ACTIONS.CLIENT_PRODUCTION_SEARCH
        });
    }
    catch (error) {
        console.error('LOG: upsert error', error);
        yield put(headerShowAction({
            data: error.response.data.data,
        }));

        yield put({
            type: CLIENT_PRODUCTION_ACTIONS.CLIENT_PRODUCTION_UPSERT_ERROR,
        });
    }
}

function* upsert({
    _id,
    ...payload
}) {
    if (_id) {
        yield update(_id, payload);
    }
    else {
        yield insert(payload);
    }
}

export default [
    takeFirstSagaUtil(CLIENT_PRODUCTION_ACTIONS.CLIENT_PRODUCTION_SEARCH, search),
    takeFirstSagaUtil(CLIENT_PRODUCTION_ACTIONS.CLIENT_PRODUCTION_UPSERT, upsert),
    takeFirstSagaUtil(CLIENT_PRODUCTION_ACTIONS.CLIENT_PRODUCTION_EDIT, edit),
];
